export default __webpack_public_path__ + "static/media/settings activate kindred.d574b87e.png";